/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { pick } from 'ramda'
import React from 'react'
import TextareaAutosize from 'react-textarea-autosize'

import { useInputStyle } from '../../utils/styles/input'

const TextArea = ({ placeholder, value, onChange, rows, ...props }) => {
  const handleChange = e => {
    if (onChange) onChange(e.target.value)
  }

  const style = css`
    ${useInputStyle(props)}
    flex: auto;
  `

  return (
    <TextareaAutosize
      className="textare"
      autoComplete="none"
      css={style}
      placeholder={placeholder}
      value={value || ''}
      minRows={rows}
      onChange={handleChange}
      {...pick(['onBlur', 'onFocus', 'onKeyUp'], props)}
    />
  )
}

export default TextArea
